import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

// Hooks
import useParameterUrl from "./../@utility/hooks/useParameterUrl";

// Redux
import { setSetting } from './../@core/redux/actions/app/menuSetting';
import { setStatusDropdown } from "./../@core/redux/actions/app/dropdrown";
import { setDataPopupContact } from "./../@core/redux/actions/app/popup";

// Auth
import { isToken, isUserLoggedIn } from "./../@core/auth/utils";

// Services (คงของเดิม)
import { loadSetting } from './../@core/services/appService';
import { checkAuthToken } from './../@core/services/appService';

// Storage helpers
import { getStorage, setStorage } from "./../@utility/app/storage";

// Layout
import Layouts from "./app-mode/Layouts";

const ViewsModule = ({ loadRoutes }) => {
  const dispatch = useDispatch();
  const statusDropdown = useSelector(state => state.reduxAppDropdown.status);
  const parsed = useParameterUrl();
  const { token } = parsed;

  const [loadContent, setLoadContent] = useState(false);

  const clickFullScreen = () => {
    if (statusDropdown === true) {
      dispatch(setStatusDropdown(false));
    }
  };

  // ====== NEW: cache-first + revalidate ใน ViewModule ======
  useEffect(() => {
    if (!loadRoutes) return;
    if (!isToken()) return;

    // 1) เติมจาก cache ก่อน (ถ้ามี)
    try {
      const raw = getStorage('setting');
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          dispatch(setSetting(cached));
        }
      }
    } catch {
      // ignore parse error
    }

    // 2) ยิง API ตามเดิม แล้วอัปเดต cache + redux
    loadSetting().then((data) => {
      if (data?.result !== undefined && data?.result !== null) {
        try {
          setStorage('setting', JSON.stringify(data.result));
          setStorage('agent_contact', JSON.stringify(data.result?.agent_contact));
          setStorage('agent_logo', JSON.stringify(data.result?.agent?.agent_image));
        } catch {
          // ignore cache write error
        }

        dispatch(setSetting(data.result));
      }
    }).catch(() => {
      // เงียบไว้: ถ้า API ล่ม แต่มี cache แล้วก็ใช้งานต่อได้
    });
  }, [dispatch, loadRoutes]);

  useEffect(() => {
    if (!loadRoutes) return;
    if (!isToken()) return;

    if (isUserLoggedIn()) {
      setLoadContent(true);
      return;
    }

    if (token !== null && token !== undefined && token !== "undefined" && token !== "") {
      checkAuthToken(token).then((code) => {
        setLoadContent(true);
        if (code === 200) {
          dispatch(setDataPopupContact(true));
        }
      }).catch(() => {
        setLoadContent(true);
      });
    } else {
      setLoadContent(true);
    }
  }, [dispatch, token, loadRoutes]);

  return (
    loadContent && (
      <div onClick={clickFullScreen}>
        <Router>
          <Layouts loadRoutes={loadRoutes} />
        </Router>
      </div>
    )
  );
}

export default ViewsModule;
